import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { EsignatureProvider } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type EsignatureConfigViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  providerOptions: { id: string; displayId: string }[];
  provider: EsignatureProvider;
  credentialsValue?: { displayId: string; id: string } | null;
  credentials: string;
  sandboxModeValue?: { displayId: string; id: string } | null;
  sandboxMode: boolean;
  webhookSecretValue?: { displayId: string; id: string } | null;
  webhookSecret: string;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
};

export const EsignatureConfigViewForm: React.FC<EsignatureConfigViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      providerOptions = [],
      provider = "" as EsignatureProvider,
      credentials = "{}",
      sandboxMode = false,
      webhookSecret = "",
      enabled = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupEsignatureConfigLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowString
                  value={
                    provider
                      ? providerOptions.find(
                          (o: { id: string }) => o.id === provider
                        )?.displayId || provider
                      : ""
                  }
                  label={langStore.EsignatureConfigProviderLabel}
                />
                <InputCodeEditor
                  value={credentials}
                  onChange={() => {}}
                  label={langStore.EsignatureConfigCredentialsLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowBoolean
                  value={sandboxMode}
                  label={langStore.EsignatureConfigSandboxModeLabel}
                />
                <ShowMultiLine
                  value={webhookSecret}
                  label={langStore.EsignatureConfigWebhookSecretLabel}
                />
                <ShowBoolean
                  value={enabled}
                  label={langStore.EsignatureConfigEnabledLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
